import { render, staticRenderFns } from "./backlog.vue?vue&type=template&id=424b8e2e&scoped=true&"
import script from "./backlog.vue?vue&type=script&lang=js&"
export * from "./backlog.vue?vue&type=script&lang=js&"
import style0 from "./backlog.vue?vue&type=style&index=0&id=424b8e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b8e2e",
  null
  
)

export default component.exports